"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var modal_1 = __importDefault(require("../../../plugins/modal"));
exports.default = (function (props) {
    var existingBundle = props.existingBundle, activeSubscriber = props.activeSubscriber, newBundleConfirmationContent = props.newBundleConfirmationContent, newBundleConfirmationEnabled = props.newBundleConfirmationEnabled;
    var _a = __read((0, react_1.useState)(false), 2), newBundleWarningClosed = _a[0], setNewBundleWarningClosed = _a[1];
    var _b = __read((0, react_1.useState)(false), 2), showModal = _b[0], setShowModal = _b[1];
    (0, react_1.useEffect)(function () {
        if (newBundleConfirmationEnabled) {
            setShowModal(!existingBundle && !!activeSubscriber);
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'bundler__existing_bundler_modal_shown',
                });
            }
        }
    }, []);
    return (react_1.default.createElement(modal_1.default, { isOpen: showModal && !newBundleWarningClosed, handleClose: function () { return setNewBundleWarningClosed(true); }, style: { content: { padding: '30px', borderRadius: '15px', maxWidth: '600px' } } },
        react_1.default.createElement("div", { className: 'confirmationModal' },
            react_1.default.createElement("h2", { id: 'newBundleWarningModalTitle' }, "Heads Up"),
            react_1.default.createElement("p", null, newBundleConfirmationContent),
            react_1.default.createElement("button", { className: 'button btn-form btn-outline', onClick: function () { return (window.location.href = '/account'); } }, "Edit Existing Bundle"),
            react_1.default.createElement("button", { className: 'button btn-form', onClick: function () { return setNewBundleWarningClosed(true); } }, "Continue"))));
});
